import React from 'react'
import { useNavigate,useParams } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import {
	CHeader,
	CHeaderNav,
	CHeaderToggler,
	CHeaderDivider,
	CFooter,
	CRow,
	CCol,
	CContainer,
	CForm,
	CFormInput,
	CFormSelect,
	CInputGroup,
	CInputGroupText,
	CButton,
	CCard,
	CCardHeader,
	CCardBody,
	CCardFooter,
	CImage,
	CLink,
	CTooltip,
	CSpinner,
	CBadge,
} from '@coreui/react';
import CIcon from '@coreui/icons-react'
import NumberFormat from 'react-number-format';
import { isMobile } from "react-device-detect";
import {
	MyButton,
	MyDialogview,
	MyDialogform,
	MyDialoglookup,
	MyDialogformantrian,
	MyHeaderProfile,
	MyKalendercheck,
} from '../../components/index'
import { Konfirm } from '../../helpers/onConfirm'
import { UFunc } from '../../helpers/functions'

const pjson 	= require('../../../package.json')
const Bayar = (props) => {
	const {
		setLoading,showToast,prosesExpired,setSessionaktif 
	} = props;
	const { tabel_id } 				= useParams(); 

	//--DOM--/
	const uNavigate 				= useNavigate();
	const uDispatch 				= useDispatch();
	//--END DOM--/

	const uRekammedisID				= parseInt(tabel_id) || 0;
	const uBahasaObj  				= useSelector(state => state.listBahasa);
	const uActiveroute  			= useSelector(state => state.activeRoute);
	const uSettingObj 				= useSelector(state => state.gListUserSetting);
	const uIsScrollBottom			= useSelector(state => state.gIsScrollBottom);
	const uEfekapp					= useSelector(state => state.effectApp);
	const uUrlbefore 				= useSelector(state => state.gUrlbefore);
	const uHTMLstylenota			= useSelector(state => state.gHTMLstyleNota);

	const [uEfekview,setEfekview] 	= React.useState(false);
	const uMaxData					= isMobile ? (uSettingObj.jml_mobile || 10) : (uSettingObj.jml_laporan || 100);
	const uKeywordobj				= JSON.parse(localStorage.getItem("listkeyword")) || {};
	const uTokenObj					= JSON.parse(localStorage.getItem("token")||"{}");
	const uIsPengelola				= (uTokenObj.userhak==="FREEROLE"||uTokenObj.userhak==="ADMIN");
	const [uHtml500msg,setHtml500msg]		= React.useState(); 
	const [uTimeelapse,setTimeelapse]		= React.useState(0); 
	const uSystemsettingObj			= useSelector(state => state.gSystemsetting);
	const [uFirstload,setFirstload]	= React.useState("YA"); 
	const uDatacabangArr		= JSON.parse(localStorage.getItem("cabanglist")||"[]")

	const [uIsLoadingform,setLoadingform]	= React.useState(false)
	const [uIsFormupdate,setFormupdate]		= React.useState(false)
	const [uEfekform,setEfekform]			= React.useState(false)
	//const uDataloadObj						= useSelector(state => state.kasirdata) || {};
	const [uDataloadObj,setDataloadObj]		= React.useState({})
	const [uDatamainObj,setDatamainObj]		= React.useState({})
	const [uDataterapiArr,setDataterapiArr]	= React.useState([])
	const [uDatapaymentArr,setDatapaymentArr]= React.useState([])
	const [uDataasuransiArr,setDataasuransiArr]= React.useState([])
	const [uTimeRunning,setTimeRunning]		= React.useState(new Date())
	const [uDatacetakObj,setDatacetakObj]	= React.useState({});

	//--DLG_FORM--/
	const [uDlgformheader,setDlgformheader]	= React.useState("")
	const [uIsDlgformshow,setDlgformshow]	= React.useState(false)
	const [uDlgformObj,setDlgformObj]		= React.useState({})
	//--END DLG_FORM--/

	//--DLG_VIEW--/
	const [uDlgviewheader,setDlgviewheader]	= React.useState("")
	const [uIsDlgviewshow,setDlgviewshow]	= React.useState(false)
	//--END DLG_VIEW--/

	//--DLG_LOOKUP--/
	const [uIsDlglookupshow,setDlglookupshow]	= React.useState(false)
	const [uDlglookupjenis,setDlglookupjenis]	= React.useState("")
	const [uDlglookupheader,setDlglookupheader]	= React.useState("")
	const [uInpDlglookup,setInpDlglookup]		= React.useState("")
	const [uDataDlglookupArr,setDataDlglookupArr]	= React.useState([])
	//--END DLG_LOOKUP--/

	//--DLG_FORM--/
	const [uISDlgformntrianshow,setDlgformntrianshow]= React.useState(false)
	const uDataformantrianObj				= JSON.parse(useSelector(state => state.gFormantrianstr) || "{}");
	//--END DLG_FORM--/

	//--SETTING_CETAK--/
	const uCabanginitObj 		= useSelector(state => state.gCabangatribut) || {};
	const uUrllogoDefault		= pjson.homepage+"api/images/header_nota.png";
	const uSettingcetakObj		= JSON.parse(localStorage.getItem("settingnota")) || {};
	const uLebarKertas			= parseInt(uSettingcetakObj.lebarkertas)||0;
	const uMarginKiri			= parseInt(uSettingcetakObj.marginkiri)||1;
	const uFontsize				= parseInt(uSettingcetakObj.fontsize)||12;
	const uViewLogo				= uSettingcetakObj.view_image_nota ||"TIDAK";
	const uFontstyle			= uSettingcetakObj.fontstyle || "Courier, Courier New, Sans Serif";
	const uFrameExport 			= document.getElementById("ifmcontentstoprint");
	//--END SETTING_CETAK--/

	//--DOM--/
	const uScreenwidth				= window.outerWidth;

	const uISCellphone				= uScreenwidth <= 425;
	const uISTablet					= uScreenwidth > 425 && uScreenwidth <= 768;
	const uISDesktop				= uScreenwidth > 768;
	//--END DOM--/

	//---HANDEL--/
	const hdlKDownDocument = (_EV) => {
		if(_EV.keyCode === 120) {
			document.getElementById("btnSimpanmain") && 
				document.getElementById("btnSimpanmain").click();
			return;
		}
	}
	const hdlKlikBack = async() => {
		const vFunctionnext = () => {
			uNavigate(uUrlbefore,{replace:true})
		}

		if(uIsFormupdate) {
			if(await(Konfirm("<b>Field Pembayaran Belum Disimpan</b>.."+
				"<br/>Data Pembayaran Ada yang Telah DIRUBAH, dan BELUM Disimpan."+
				"<br/><br/>Apakah Akan Melanjutkan ?"+
				""))) vFunctionnext()
		} else vFunctionnext()
	}
	const hdlKlikReset = async() => {
		const vFunctionnext = () => {
			//uDatamainObj.tgl_bayar = undefined;
			//setDatamainObj({}); setEfekform(!uEfekform);
			initCopyloadobj(); setEfekview(!uEfekview);
		}

		if(uIsFormupdate) {
			if(await(Konfirm("<b>Field Pembayaran Belum Disimpan</b>.."+
				"<br/>Data Pembayaran Ada yang Telah DIRUBAH, dan BELUM Disimpan."+
				"<br/><br/>Apakah Tetap Akan Mereset ?"+
				""))) vFunctionnext()
		} else { apiLoadawal(); }
	}
	const hdlKlikLihatpiutang = () => {
		const vPiutangArr = uDataloadObj.piutang_arr || []; 
		setDlgviewheader("Data Piutang Pasien");
		if(vPiutangArr.length > 0) {
			setDlgviewshow(true); return;
		}

		apiLoadpiutang();
	}
	const hdlKlikBayarpiutang = async() => {
		if(await(Konfirm(
			"<b>Anda Akan Meninggalkan Pembayaran Billing</b>.."+
			"<br/>Apakah Anda Yakin ?"+
			""))) {
			uKeywordobj.kwd_kasirpiutang = uDataloadObj.pasien_caption||"";
			localStorage.setItem("listkeyword",JSON.stringify(uKeywordobj));
			uNavigate("/subbilling/kasirpiutang",{replace:true})
		}
	}
	const hdlKlikTerapitambah = () => {
		uDlgformObj.jenis_form 		= "TERAPI";
		setDlgformheader("Tambah Terapi");
		setDlgformshow(true);

		const vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			const vElfocus = document.getElementById("inpitemcaption");
			if(!isMobile) vElfocus && vElfocus.focus();
		},350);
		return;

		//--LAMA_DIHAPUS_SAJA--/
		const vTmpArr	= uDataterapiArr.map(vItems => {
			return {
				id:vItems.id,
				caption:vItems.terapi_caption,
				harga_satuan:vItems.terapi_tarif
			}
		});
		setDlglookupjenis("TERAPI");
		setDataDlglookupArr(vTmpArr);
		setDlglookupheader("Pilih: TERAPI");
		setDlglookupshow(true)
		//--END LAMA_DIHAPUS_SAJA--/
	}
	const hdlKlikTerapiedit = (_IDXKEY) => {
		_IDXKEY = _IDXKEY===undefined ? -1 : parseInt(_IDXKEY); if(_IDXKEY < 0) return;

		const vItemmainArr 			= uDatamainObj.itemmain_arr || [];
		uDlgformObj.item_idxkey 	= _IDXKEY;
		uDlgformObj.item_id 		= vItemmainArr[_IDXKEY].id || 0;
		uDlgformObj.terapisub_id 	= parseInt(vItemmainArr[_IDXKEY].id_terapi_sub) || 0;
		uDlgformObj.terapi_caption 	= vItemmainArr[_IDXKEY].caption_terapi || "";
		uDlgformObj.terapi_tarif 	= parseFloat(vItemmainArr[_IDXKEY].harga_terapi) || 0;
		uDlgformObj.terapi_qty 		= parseInt(vItemmainArr[_IDXKEY].qty) || 0;
		uDlgformObj.terapi_diskon 	= parseFloat(vItemmainArr[_IDXKEY].diskon_terapi) || 0;
		uDlgformObj.jenis_form 		= "TERAPI";

		setDlgformheader("Edit Item Terapi");
		setDlgformshow(true);

		const vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			const vElfocus = document.getElementById("inpitemqty");
			if(!isMobile) vElfocus && vElfocus.focus();
		},350);
	}
	const hdlKlikTerapihapus = async(_IDXKEY) => {
		_IDXKEY = _IDXKEY===undefined ? -1 : parseInt(_IDXKEY); if(_IDXKEY < 0) return;

		const vFunctionnext = () => {
			const vItemviewArr 		= (uDatamainObj.itemmain_arr || []).filter(
				vItems=>(vItems.status_hapus||"TIDAK")==="TIDAK");
			const vItemdeletedArr 	= (uDatamainObj.itemmain_arr || []).filter(
				vItems=>(vItems.status_hapus||"TIDAK")==="YA");

			uDatamainObj.itemmain_arr  = [];
			//console.log("(hdlKlikTerapihapus) ["+_IDXKEY+"] => "+JSON.stringify(vItemviewArr[_IDXKEY]))
			if((parseInt(vItemviewArr[_IDXKEY].id)||0) <= 0)
				vItemviewArr.splice(_IDXKEY,1);
			else {
				vItemviewArr[_IDXKEY].status_hapus = "YA";
			}
			uDatamainObj.itemmain_arr = [...vItemviewArr,...vItemdeletedArr];
			setEfekview(!uEfekview);
		}

		if(await(Konfirm(
			"Apakah Yakin Akan Menghapus Item No-"+(_IDXKEY+1)+" ?"+
			""))) vFunctionnext()
	}

	const hdlKlikAntriantambah = () => {
		const vTmpObj	= { id_pasien: uDatamainObj.id_pasien }
		uDispatch({type: "set", gFormantrianstr: JSON.stringify(vTmpObj)});
		setDlgformntrianshow(true);
	}
	const hdlKlikAntrianedit = (_IDXKEY) => {
		_IDXKEY = parseInt(_IDXKEY); if(_IDXKEY < 0) return;

		const vTmpObj 	= {
			...((uDatamainObj.janjian_arr||[])[_IDXKEY] || {}),
			idxkey: _IDXKEY,
			id_pasien: uDatamainObj.id_pasien,
		}
		uDispatch({type: "set", gFormantrianstr: JSON.stringify(vTmpObj)});

		setDlgformntrianshow(true);
	}
	const hdlKlikAntrianhapus = async(_IDXKEY) => {
		_IDXKEY = _IDXKEY===undefined ? -1 : parseInt(_IDXKEY); if(_IDXKEY < 0) return;

		const vFunctionnext = () => {
			const vJanjianviewArr 		= (uDatamainObj.janjian_arr || []).filter(
				vItems=>(vItems.status_hapus||"TIDAK")==="TIDAK");
			const vJanjiandeletedArr 	= (uDatamainObj.janjian_arr || []).filter(
				vItems=>(vItems.status_hapus||"TIDAK")==="YA");

			uDatamainObj.janjian_arr  = [];
			//console.log("(hdlKlikTerapihapus) ["+_IDXKEY+"] => "+JSON.stringify(vJanjianviewArr[_IDXKEY]))
			if((parseInt(vJanjianviewArr[_IDXKEY].id)||0) <= 0)
				vJanjianviewArr.splice(_IDXKEY,1);
			else {
				vJanjianviewArr[_IDXKEY].status_hapus = "YA";
			}
			uDatamainObj.janjian_arr = [...vJanjianviewArr,...vJanjiandeletedArr];
			setEfekview(!uEfekview);
		}

		if(await Konfirm("<b>Reservasi Akan Dihapus</b>.."+
			"<p>Apakah Anda Yakin ?</p>"+
			"")) vFunctionnext();
	}
	const hdlKlikDlgformantriansimpan = () => {
		//--SIMPAN_DI_JANJIAN_ARR--/
		//console.log("(Bayar - hdlKlikDlgformantriansimpan) uDataformantrianObj",JSON.stringify(uDataformantrianObj));
		const vCabangidx		= UFunc.getObjectIndeks(uDatacabangArr,uDataformantrianObj.id_cabang);
		const vDataantrianObj 	= {...uDataformantrianObj,
			//id_pasien: uDatamainObj.id_pasien,
			cabang_caption: (uDatacabangArr[vCabangidx]||{}).cabang_nama || "Undf Cabang",
		}

		const vArridx		= uDataformantrianObj.idxkey>=0 ? parseInt(uDataformantrianObj.idxkey) : -1;
		if(vArridx < 0)
			uDatamainObj.janjian_arr = [...(uDatamainObj.janjian_arr||[]),vDataantrianObj];
		else 
			(uDatamainObj.janjian_arr||[])[vArridx] = vDataantrianObj;

    	uDispatch({type: "set", gFormantrianstr: undefined});
		setDlgformntrianshow(false);
		//--END SIMPAN_DI_JANJIAN_ARR--/
	}
	const hdlDlgLookuptoggle = () => { setDlglookupshow(false) }
	const hdlDlgLookupPILIH = (_IDITEM) => {
		_IDITEM = parseInt(_IDITEM)||0; if(_IDITEM <= 0) return;

		let vElfocus;
		if(uDlglookupjenis==="TERAPI") {
			const vArridx	= UFunc.getObjectIndeks(uDataterapiArr,_IDITEM);
			uDlgformObj.terapisub_id 	= _IDITEM;
			uDlgformObj.terapi_caption 	= uDataterapiArr[vArridx].terapi_caption;
			uDlgformObj.terapi_tarif 	= uDataterapiArr[vArridx].terapi_tarif;
			uDlgformObj.terapi_qty 		= parseInt(uDlgformObj.terapi_qty) || 1;
			vElfocus = document.getElementById("inpitemqty");

			/*//--LAMA_DIHAPUS_SAJA--/
			const vTmpObj	= {
				id: 0,
				id_terapi_sub: _IDITEM,
				caption_terapi: uDataterapiArr[vArridx].terapi_caption,
				harga_terapi: uDataterapiArr[vArridx].terapi_tarif,
				qty: 1,
				status_hapus: "TIDAK",
			}
			uDatamainObj.itemmain_arr = [...(uDatamainObj.itemmain_arr||[]),vTmpObj];
			//--END LAMA_DIHAPUS_SAJA--*/
		} else if(uDlglookupjenis === "PAYMENT") {//--TIDAK_DIPAKAI--/
			const vArridx	= UFunc.getObjectIndeks(uDatapaymentArr,_IDITEM);
			uDlgformObj.payment_id		= uDatapaymentArr[vArridx].id;
			uDlgformObj.payment_caption	= uDatapaymentArr[vArridx].payment_caption;

			vElfocus = document.getElementById("inpjmlbayar");
		} else if(uDlglookupjenis === "ASURANSI") {
			const vArridx	= UFunc.getObjectIndeks(uDataasuransiArr,_IDITEM);
			uDlgformObj.asuransi_id		= uDataasuransiArr[vArridx].id;
			uDlgformObj.asuransi_caption= uDataasuransiArr[vArridx].asuransi_caption;

			vElfocus = document.getElementById("inpasuransinilai");
		}
		setEfekview(!uEfekview);
		hdlDlgLookuptoggle();
		
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			vElfocus && vElfocus.focus()
		},350) 
	}
	const hdlToggleDlgview = () => { setDlgviewshow(false) }
	const hdlToggleDlgform = () => { setDlgformshow(false) }
	const hdlKlikItemlookup = () => {
		const vTmpArr	= uDataterapiArr.map(vItems => {
			return {
				id:vItems.id,
				caption:vItems.terapi_caption,
				harga_satuan:vItems.terapi_tarif
			}
		});

		setInpDlglookup(uDlgformObj.terapi_caption||"");
		setDlglookupjenis("TERAPI");
		setDataDlglookupArr(vTmpArr);
		setDlglookupheader("Pilih: TERAPI");
		setDlglookupshow(true)
	}
	const hdlKDownItemlookup = (_EV) => {
		uDlgformObj.terapisub_id 	= 0;
		if(_EV.keyCode !== 13) return;
		const vTerapicaption	= (uDlgformObj.terapi_caption||"").trim();
		if(vTerapicaption === "") return;

		_EV.stopPropagation();
		_EV.preventDefault();

		const vArrCariMaster 	= uDataterapiArr.filter((vItem)=>
			vItem.terapi_caption.toUpperCase().includes((vTerapicaption).toUpperCase()));
		
		if (vArrCariMaster.length === 1) {
			uDlgformObj.terapisub_id 	= vArrCariMaster[0].id;
			uDlgformObj.terapi_caption 	= vArrCariMaster[0].terapi_caption;
			uDlgformObj.terapi_tarif 	= vArrCariMaster[0].terapi_tarif;
			uDlgformObj.terapi_qty 		= parseInt(uDlgformObj.terapi_qty) || 1;

			setEfekview(!uEfekview);
			const vElfocus = document.getElementById("inpitemqty");
			vElfocus && vElfocus.focus();
			return;
		}

		hdlKlikItemlookup();
	}
	const hdlKlikAsuransilookup = () => {
		const vTmpArr	= uDataasuransiArr.map(vItems => {
			return {
				id:vItems.id,
				caption:vItems.asuransi_caption,
			}
		});
		setDlglookupjenis("ASURANSI");
		setDataDlglookupArr(vTmpArr);
		setDlglookupheader("Pilih: ASURANSI");
		setDlglookupshow(true)
	}
	const hdlKlikAsuransi = () => {
		uDlgformObj.jenis_form 		= "ASURANSI";
		if(parseInt(uDatamainObj.id_asuransi||"0") > 0) {
			uDlgformObj.asuransi_caption= uDatamainObj.nama_asuransi;
			uDlgformObj.asuransi_id 	= uDatamainObj.id_asuransi;
			uDlgformObj.asuransi_nomor 	= uDatamainObj.nomor_asuransi;
		} else {
			const vArridx = UFunc.getObjectIndeks(uDataasuransiArr,
				(uDatamainObj.pasien_asuransi_id||0));

			if(vArridx < 0) {
				uDlgformObj.asuransi_id 	= 0;
				uDlgformObj.asuransi_caption= "";
				uDlgformObj.asuransi_nomor 	= "";
			} else {
				uDlgformObj.asuransi_id 	= uDatamainObj.pasien_asuransi_id;
				uDlgformObj.asuransi_caption= uDataasuransiArr[vArridx].asuransi_caption;
				uDlgformObj.asuransi_nomor 	= uDatamainObj.pasien_asuransi_nomor;
			}
		}
		uDlgformObj.nilai_asuransi 	= uDatamainObj.nilai_asuransi;

		setDlgformheader("Tanggungan Asuransi");
		setDlgformshow(true);

		const vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
				
			const vElfocus = document.getElementById("inpasuransinilai");
			if(!isMobile) vElfocus && vElfocus.focus();
		},350);
	}
	const hdlKlikPaymenttambah = () => {
		const vNilaisisa	= parseFloat(uDatamainObj.nilai_sisa)||0;
		if(vNilaisisa <= 0) {
			showToast("<b>Nilai Pembayaran Sudah Melebihi Tagihan</b>.."+
				"<br/>Hapus Terlebih Dahulu Salah Satu Metode Pembayaran yang Ada !"+
				""); return;
		}

		uDlgformObj.jenis_form 		= "PAYMENT";
		setDlgformheader("Input Metode Pembayaran");
		setDlgformshow(true);

		const vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			const vElfocus = document.getElementById("inppaymentcaption");
			if(!isMobile) vElfocus && vElfocus.focus();
		},350);
	}
	const hdlKlikPaymentlookup = () => {
		const vTmpArr	= uDatapaymentArr.map(vItems => {
			return {
				id:vItems.id,
				caption:vItems.payment_caption,
			}
		});
		setDlglookupjenis("PAYMENT");
		setDataDlglookupArr(vTmpArr);
		setDlglookupheader("Pilih: METODE PEMBAYARAN");
		setDlglookupshow(true)
	}
	const hdlKlikPaymenthapus = async(_IDXKEY) => {
		_IDXKEY = parseInt(_IDXKEY); if(_IDXKEY < 0) return;

		if(await Konfirm("<b>Metode Pembayaran Akan Dihapus</b>.."+
			"<br/>Apakah Anda Yakin ?"+
			"")) {
			(uDatamainObj.payment_arr||[]).splice(_IDXKEY,1);
			setEfekview(!uEfekview);
		}
	}
	const hdlKlikSimpanmain = () => {
		//if(!uIsFormupdate) return;
		let vElfocus	= document.getElementById("inptglbayar");
		if((uDatamainObj.tgl_bayar||"") === "") {
			vElfocus && vElfocus.focus();
			showToast("Tanggal Bayar Tidak Valid !"); return
		}
		const vTglbayarDT	= UFunc.toDatetime(uDatamainObj.tgl_bayar+" 00:00:00");
		const vTglnowDT		= UFunc.toDatetime(UFunc.DbDate()+" 00:00:00");
		const vTglperiksaDT	= UFunc.toDatetime(uDataloadObj.tgl_periksa+" 00:00:00");
		if(vTglbayarDT > vTglnowDT) {
			vElfocus && vElfocus.focus();
			showToast("Tanggal Bayar Melewati Tanggal Hari Ini !"); return
		}
		if(vTglbayarDT < vTglperiksaDT) {
			vElfocus && vElfocus.focus();
			showToast("Tanggal Bayar Lebih Lama Dari Tanggal Periksa ! "); return
		}
		if((uDatamainObj.itemmain_arr||[]).
			filter(vItems=>(vItems.status_hapus||"TIDAK")==="TIDAK").length <= 0) {
			showToast("Item Terapi Tidak Ada ! "); return
		}
		vElfocus	= document.getElementById("inpbayar");
		if(uDataloadObj.status_bayar !== "KASIR")
			if((parseInt(uDatamainObj.nilai_uang)||0) <= 0) {
				vElfocus && vElfocus.focus();
				showToast("JML Bayar Tidak Valid ! "); return
			}

		uDlgformObj.jenis_form = "FORMMAIN";
		setDlgformheader("Pembayaran Billing");
		setDlgformshow(true)

		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			document.getElementById("btnDialogSimpan") && 
				document.getElementById("btnDialogSimpan").focus();
		},350)
	}
	const hdlKlikDlgformsimpan = () => { 
		if(uDlgformObj.jenis_form === "FORMMAIN") 
			{ apiProsessimpan(); return; }
		if(uDlgformObj.jenis_form === "ASURANSI") 
			{ prosesFormasuransi(); return; }
		if(uDlgformObj.jenis_form === "PAYMENT") 
			{ prosesFormpayment(); return; }
		if(uDlgformObj.jenis_form === "TERAPI") 
			{ prosesFormitem(); return; }
	}
	//---END HANDEL--/

	//---INIT_PROCESS--/
	const prosesFormitem = () => {
		let vElfocus = document.getElementById("inpitemcaption");
		if((parseInt(uDlgformObj.terapisub_id)||0) <= 0) {
			vElfocus && vElfocus.focus();
			showToast("Item Terapi Harus Dipilih Terlebih Dahulu !"+
				""); return
		}
		vElfocus = document.getElementById("inpitemqty");
		if((parseInt(uDlgformObj.terapi_qty)||0) <= 0) {
			vElfocus && vElfocus.focus();
			showToast("QTY Terapi Tidak Valid !"+
				""); return
		}

		const vIdxkey	= uDlgformObj.item_idxkey===undefined ? -1 : parseInt(uDlgformObj.item_idxkey);
		if(vIdxkey < 0) {
			const vTmpObj	= {
				id: uDlgformObj.item_id || 0,
				id_terapi_sub: uDlgformObj.terapisub_id,
				caption_terapi: uDlgformObj.terapi_caption,
				harga_terapi: parseFloat(uDlgformObj.terapi_tarif)||0,
				qty: parseInt(uDlgformObj.terapi_qty)||1,
				diskon_terapi: parseFloat(uDlgformObj.terapi_diskon)||0,
				status_hapus: "TIDAK",
			}

			uDatamainObj.itemmain_arr = [...(uDatamainObj.itemmain_arr||[]),vTmpObj];
		} else {
			(uDatamainObj.itemmain_arr||[])[vIdxkey].id_terapi_sub 	= parseInt(uDlgformObj.terapisub_id)||0;
			(uDatamainObj.itemmain_arr||[])[vIdxkey].caption_terapi = uDlgformObj.terapi_caption||"";
			(uDatamainObj.itemmain_arr||[])[vIdxkey].harga_terapi 	= parseFloat(uDlgformObj.terapi_tarif)||0;
			(uDatamainObj.itemmain_arr||[])[vIdxkey].qty 			= parseInt(uDlgformObj.terapi_qty)||1;
			(uDatamainObj.itemmain_arr||[])[vIdxkey].diskon_terapi 	= parseFloat(uDlgformObj.terapi_diskon)||0;
			(uDatamainObj.itemmain_arr||[])[vIdxkey].status_hapus 	= "TIDAK";
		}

		initNilaibruto();
		hdlToggleDlgform();
	}
	const prosesFormasuransi = () => {
		const vAsuransiID 	= parseInt(uDlgformObj.asuransi_id||"0");
		const vAsuransinilai= parseFloat(uDlgformObj.nilai_asuransi||"0");

		let vElfocus = document.getElementById("inpasuransicaption");
		if(vAsuransiID <= 0 && vAsuransinilai > 0) {
			vElfocus && vElfocus.focus();
			showToast("Nama Asuransi Harus Dipilih Terlebih Dahulu !"); return;
		}
		vElfocus = document.getElementById("inpasuransinilai");
		if(vAsuransiID > 0 && vAsuransinilai <= 0) {
			vElfocus && vElfocus.focus();
			showToast("Nilai Tanggungan Asuransi Belum Ditentukan !"); return;
		}

		const vNilaibruto1	= parseFloat(uDatamainObj.nilai_bruto || "0") -
			parseFloat(uDatamainObj.diskon || "0");

		if(vAsuransinilai > vNilaibruto1) {
			vElfocus && vElfocus.focus();
			showToast("Nilai Klaim Asuransi Melebihi Nilai Tagihan !"); return;
		}

		uDatamainObj.id_asuransi 	= parseInt(uDlgformObj.asuransi_id)||0;
		uDatamainObj.nama_asuransi 	= uDlgformObj.asuransi_caption||"";
		uDatamainObj.nomor_asuransi = (uDlgformObj.asuransi_nomor||"").trim();
		uDatamainObj.nilai_asuransi = parseFloat(uDlgformObj.nilai_asuransi)||0;

		hdlToggleDlgform();
	}
	const prosesFormpayment = () => {
		const vPaymentID	= parseInt(uDlgformObj.payment_id)||0;
		const vJumlahbayar	= parseFloat(uDlgformObj.jml_bayar)||0;
		if(vJumlahbayar <= 0 && vPaymentID <= 0) {
			setDlgformshow(false); return;
		}

		const vFilterArr	= (uDatamainObj.payment_arr||[]).filter((vItems)=>
			(parseInt(vItems.id_payment)||0) === vPaymentID);
		let vElfocus		= document.getElementById("inppaymentcaption");
		//alert(vPaymentidx+" == "+vPaymentID+" == "+JSON.stringify(uDatamainObj.payment_arr||[]));
		if(vFilterArr.length > 0) {
			vElfocus && vElfocus.focus();
			showToast("<b>Metode Pembayaran Sudah Ada</b>.."+
				"<br/>Mohon Diperbaiki !"+
				""); return
		}

		const vNilaisisa	= parseFloat(uDatamainObj.nilai_sisa)||0;
		const vNilaisisabaru= vNilaisisa - vJumlahbayar; 
		vElfocus	= document.getElementById("inpjmlbayar");
		if(vJumlahbayar <= 0) {
			vElfocus && vElfocus.focus();
			showToast("<b>Jumlah Pembayaran Tidak Valid</b>.."+
				"<br/>Mohon Diperbaiki !"+
				""); return
		}

		if(vPaymentID > 0 && vNilaisisabaru < 0) {
			vElfocus && vElfocus.focus();
			showToast("<b>Jumlah Pembayaran Melebihi Nilai Tagihan</b>.."+
				"<br/>Mohon Diperbaiki !"+
				""); return
		}

		const vTmpObj	= {
			id_payment: vPaymentID,
			nama_payment: uDlgformObj.payment_caption||"Tunai (CASH)",
			ket_payment: (uDlgformObj.payment_ket||"").trim(),
			jml_bayar: parseFloat(uDlgformObj.jml_bayar)||0,
		}

		uDatamainObj.payment_arr = [...(uDatamainObj.payment_arr||[]),vTmpObj];

		if(vNilaisisabaru <= 0) {
			setDlgformshow(false);

			let vTimeout = setTimeout(()=>{
				clearTimeout(vTimeout);
				document.getElementById("btnSimpanmain") && 
					document.getElementById("btnSimpanmain").focus();
			},350)
			return;
		}

		uDlgformObj.payment_caption = undefined;
		uDlgformObj.payment_id 		= undefined;
		uDlgformObj.payment_ket 	= undefined;
		uDlgformObj.jml_bayar 		= 0;

		setEfekview(!uEfekview);

		document.getElementById("inppaymentcaption") &&
			document.getElementById("inppaymentcaption").focus();
	}

	const initCopyloadobj = () => {
		//console.log("(Bayar - initCopyloadobj) uDataloadObj => "+JSON.stringify(uDataloadObj))
		setDatamainObj({...uDataloadObj,init_difference:"YA"});
	}
	const initNilaibruto = () => {
		const vItemsArr = uDatamainObj.itemmain_arr || []
		const vJumlah = vItemsArr.reduce((SUM,vItems) => 
			SUM + ((vItems.status_hapus||"TIDAK")==="TIDAK" 
				? ( (parseFloat(vItems.harga_terapi||0) - parseFloat(vItems.diskon_terapi||0)) * parseInt(vItems.qty||1) ) : 0)
		, 0);

		uDatamainObj.nilai_bruto = vJumlah;
		setEfekview(!uEfekview)
	}
	const initNilaiakhir = () => {
		const vNilaibruto 	= (parseFloat(uDatamainObj.nilai_bruto) || 0);
		const vNilaidiskon	= (parseFloat(uDatamainObj.diskon) || 0);
		const vMaxdiskon 	= (parseFloat(uSystemsettingObj.persen_diskonmax) || 100);
		const vNilaiasuransi= (parseFloat(uDatamainObj.nilai_asuransi) || 0);
		const vNilaibayar	= (parseFloat(uDatamainObj.terbayar) || 0);

		const vNilaiakhir	= vNilaibruto - vNilaidiskon - vNilaiasuransi - vNilaibayar;
		uDatamainObj.nilai_akhir = vNilaiakhir;
	}
	const initCetaknota = () => {
		const vContent 	= contentCetaknota();
		if(vContent === "") return

		var pri 		= uFrameExport.contentWindow;
		pri.document.open();
		pri.document.write(vContent);
		pri.document.close();
		pri.window.focus();
		pri.window.print();
	}
	//---END INIT_PROCESS--/

	//---CONTENT--/
	const contentNota = () => {
		if(uISCellphone) return "";
		if(uHtml500msg) return "";

		return (
		<CCard className="classbgcard mb-3">
		<CCardHeader className="py-0 pt-1 classfontsmaller text-muted"><small>Data Nota</small></CCardHeader>
		<CCardBody className="py-1 px-2">
			<small>
			<CRow className="mx-0 my-1">
			<CCol>Tanggal</CCol>
			<CCol className="text-end fw-bolder">
				{uIsPengelola ? (
				<CFormInput size="sm" type="date"
					value={uDatamainObj.tgl_bayar||""}
					onChange={(e)=>{uDatamainObj.tgl_bayar = e.target.value;setEfekview(!uEfekview)}}
					id="inptglbayar"/>
				) : (
				<div className="">{UFunc.WaktuAngka(uTimeRunning)}</div>
				)}
			</CCol>
			</CRow>

			{(uDataloadObj.status_bayar||"KASIR")!=="KASIR" && (
			<CRow className="mx-0 my-2">
			<CCol>Tanggal PERIKSA</CCol>
			<CCol className="text-end fw-bolder">
				{UFunc.TglAngka(uDatamainObj.tgl_periksa)}
			</CCol>
			</CRow>
			)}

			<CRow className="mx-0 my-2">
			<CCol>Dokter</CCol>
			<CCol className="text-end fw-bolder text-primary">{uDatamainObj.nama_dokter||"UNDF, DRG"}</CCol>
			</CRow>

			{((uDataloadObj.status_bayar||"KASIR")==="KASIR" && 
				(uDatamainObj.status_piutang||"TIDAK")==="YA") && (
			<CRow className="mx-0 my-2">
			<CCol>Status Cicilan (Piutang)</CCol>
			<CCol className="text-end fw-bolder">
				<CBadge color="danger">Ada Cicilan</CBadge>
				<span className="mx-1">&middot;</span>
				{(uDatamainObj.isLoadpiutang||false)===true ? (
					<CSpinner color="danger" size="sm"/>
				) : (
				<>
				<CTooltip className="d-none d-lg-block" content="--Lihat Cicilan (Piutang)">
				<CLink className="classcursorpointer"
					onClick={()=>hdlKlikLihatpiutang()}>
				<CImage src={pjson.homepage+"api/images/icon_piutang.png"} className="classblinking " height={30}/>
				</CLink>
				</CTooltip>
				<span className="mx-1">&middot;</span>
				<CTooltip className="d-none d-lg-block" content="--Kembali ke Pembayaran Piutang">
				<CLink className="classcursorpointer"
					onClick={()=>hdlKlikBayarpiutang()}>
					<CIcon icon="cilChevronDoubleRight" className="classikonbox text-danger" height={25}/>
				</CLink>
				</CTooltip>
				</>
				)}
			</CCol>
			</CRow>
			)}
			</small>
		</CCardBody>
		</CCard>
		)
	}
	const contentItem = () => {
		if(uISCellphone) return "";
		if(uHtml500msg) return "";
		
		const vItemsArr	= (uDatamainObj.itemmain_arr || []).filter(
			vItems=>(vItems.status_hapus||"TIDAK")==="TIDAK");

		return (
		<CCard className="classbgcard mb-3" style={{flex:"1 0 0"}}>
		<CCardHeader className="py-0 pt-1 classfontsmaller text-muted d-flex justify-content-between">
			<small>Item Terapi</small>
			{(uDataloadObj.status_bayar||"PIUTANG")==="KASIR" && (
			<>
				<CTooltip className="d-none d-lg-block" content="--Tambah Item Terapi">
				<CLink className="classcursorpointer classikontabel classikontambah"
					onClick={()=>hdlKlikTerapitambah()}/>
				</CTooltip>
			</>
			)}
		</CCardHeader>

		<CCardBody className="px-0">
			<small>
			<table className="table table-borderless table-striped table-hover" id="idtabelitem">
			<thead>
			<tr className="align-top p-0">
				<td width={25} className="p-0"/>
				<td className="p-0"/>
				<td width={80} className="p-0"/>
				<td width={80} className="p-0 d-md-none"/>
				<td width={100} className="p-0 d-none d-lg-table-cell"/>
			</tr>
			</thead>

			<tbody>
			{vItemsArr.map((vItems,vKeys)=>{
				const {
					id,id_terapi_sub,caption_terapi,harga_terapi,keterangan,qty,
					diskon_terapi
				} = vItems;

				const vNilaisubtotal	= (parseFloat(harga_terapi||0) - parseFloat(diskon_terapi||0)) * parseInt(qty||1);

				return (
				<>
				<tr className="align-top" key={vKeys}>
					<td width={25} className="text-end">{(vKeys+1)}.</td>
					<td className="text-start">
						<div className="fw-bolder">{caption_terapi}</div>
						<ul className="my-0 px-0 ps-3">
						<li>
							<small>
							<b className="text-primary">{UFunc.formatAngka(qty||1)}</b>unt

							<span className="mx-1">x</span>
							
							{(parseFloat(diskon_terapi)||0) > 0 ? (
							<>
							(
								<span className="text-primary">{UFunc.formatAngka(harga_terapi)}</span>
								<span className="mx-1">-</span>
								<span className="text-danger">{UFunc.formatAngka(diskon_terapi)}</span>
							)
							</>
							) : (
								<span className="text-primary">{UFunc.formatAngka(harga_terapi)}</span>
							)}
							</small>
						</li>

						{(keterangan||"").trim() !== "" && (
						<li>
							<small className="fst-italic">{keterangan}</small>
						</li>
						)}
						</ul>
					</td>

					<td width={80} className="text-center">
					{(uDataloadObj.status_bayar||"PIUTANG")==="KASIR" ? (
					<>
						<CTooltip className="d-none d-lg-block" content={"--EDIT Terapi No-"+(vKeys+1)}>
						<CLink className="classcursorpointer classikontabel classikonedit"
							onClick={()=>hdlKlikTerapiedit(vKeys)}/>
						</CTooltip>

						<CTooltip className="d-none d-lg-block" content={"--Hapus Terapi No-"+(vKeys+1)}>
						<CLink className="classcursorpointer classikontabel classikonhapus"
							onClick={()=>hdlKlikTerapihapus(vKeys)}/>
						</CTooltip>
					</>
					) : (<>&middot;</>)}
					</td>

					<td className="text-end text-success">
						<small className="d-lg-none">{UFunc.formatAngka(vNilaisubtotal)}</small>
						<span className="d-none d-lg-block">{UFunc.formatAngka(vNilaisubtotal)}</span>
					</td>
				</tr>
				</>
				)
			})}
			</tbody>
			</table>
			</small>
		</CCardBody>
		</CCard>
		)//->
	}
	const contentCatatan = () => {
		if(uISCellphone) return "";
		if(uHtml500msg) return "";
		if((uDataloadObj.status_bayar||"PIUTANG")!=="KASIR") return "";//return (<>{uDataloadObj.status_bayar}</>);
		
		return (
		<CCard className="classbgcard mb-3">
		<CCardHeader className="py-0 pt-1 classfontsmaller text-muted"><small>Catatan untuk Pasien</small></CCardHeader>
		<CCardBody className="py-1 px-2 px-lg-4">
			<small>
			<CRow className="my-2">
			<CCol md="4">Catatan Dokter</CCol>
			<CCol className="fw-bolder">{uDatamainObj.note_dokter||"-"}</CCol>
			</CRow>

			<CRow className="my-1">
			<CCol md="4">Cat.Tambahan</CCol>
			<CCol className="">
				<CFormInput size="sm" maxLength={255}
					value={uDatamainObj.note_nota||""}
					onChange={(e)=>{uDatamainObj.note_nota = e.target.value;setEfekview(!uEfekview)}}
					id="inpcatatanlain"/>
			</CCol>
			</CRow>

			<div className="my-3 classborderbottom"/>

			<CRow className="my-1">
			<CCol md="4">Catatan KASIR</CCol>
			<CCol className="">
				<CFormInput size="sm" maxLength={255}
					value={uDatamainObj.note_kasir||""}
					onChange={(e)=>{uDatamainObj.note_kasir = e.target.value;setEfekview(!uEfekview)}}
					id="inpcatatankasir"/>
			</CCol>
			</CRow>
			</small>
		</CCardBody>
		</CCard>
		)//->
	}
	const contentAntrian = () => {
		if(uHtml500msg) return "";
		if((uDataloadObj.status_bayar||"PIUTANG")!=="KASIR") return "";

		const vJanjianArr	= (uDatamainObj.janjian_arr || []).filter(
			vItems=>(vItems.status_hapus||"TIDAK")==="TIDAK");

		return (
		<CCard className="classbgcard mb-3">
		<CCardHeader className="py-0 d-flex justify-content-between">
			<div className="text-muted classfontsmaller mt-1">
			<small>Reservasi Berikutnya</small>
			</div>

			<div>
				<MyKalendercheck height={28} {...props}/>
				
				<span className="me-1"/>

				<CTooltip content="--Tambah Reservasi Berikutnya" className="d-none d-lg-block">
				<CLink onClick={()=>hdlKlikAntriantambah()} className="classcursorpointer classikontabel classikontambah"/>
				</CTooltip>
			</div>
		</CCardHeader>

		<CCardBody>
			<small className="d-block">
			{(uDatamainObj.note_kasir_to||"")!=="" && (
			<>
			<div className="text-danger fst-italic">&middot; {uDatamainObj.note_kasir_to} &middot;</div>
			<div className="my-3 classborderbottom"/>
			</>
			)}

			{vJanjianArr.length > 0 ? (
				<ol className="my-0 px-3">
					{vJanjianArr.map((vItems,vKeys)=>{
						const {
							id,tgl_antri,jam_awal,cabang_caption,dokter_caption,dokter_id,
							no_urut,no_ruang,
						} = vItems;

						return (
						<li key={vKeys} className={"p-1 px-2 classborderbottom"+((parseInt(id)||0) > 0 ? " bg-light":"")}>
						<div className="d-flex justify-content-between">
						<div>
							<b>{UFunc.HariAngka(tgl_antri)}</b>
							<span className="mx-1">&middot;</span>
							<span className="fst-italic text-primary">
							({cabang_caption})
							</span>

							<div>
							{(parseInt(dokter_id)||0) > 0 ? (
							<small>
								Jam <b>{(jam_awal||"").substring(0,5)}</b>
								<span className="mx-1">&middot;</span>
								<b>{dokter_caption||"DRG.UNDF"}</b>
								<span className="mx-1">&middot;</span>
								Rg.No-<b>{no_ruang}</b>
							</small>
							) : (
							<small className="text-muted">NON JANJIAN</small>
							)}
							</div>

							</div>

							<div>
						</div>

						<div>
							{(parseInt(id)||0) <= 0 && (
							<CTooltip className="d-none d-lg-block" content="Edit Reservasi">
							<CLink onClick={()=>hdlKlikAntrianedit(vKeys)} className="classcursorpointer classikontabel classikonedit"/>
							</CTooltip>
							)}

							<CTooltip className="d-none d-lg-block" content="Hapus Reservasi">
							<CLink onClick={()=>hdlKlikAntrianhapus(vKeys)} className="classcursorpointer classikontabel classikonhapus"/>
							</CTooltip>
						</div>
						</div>
						</li>
						)
					})}
				</ol>
			) : (
			<small className="d-block text-primary fst-italic text-center">
				Belum Ada Reservasi
			</small>
			)}
			</small>
		</CCardBody>
		</CCard>
		)//>
	}
	const contentBayar = () => {
		if(uISCellphone) return "";
		if(uHtml500msg) return "";

		const vColorsisa	= parseInt(uDatamainObj.nilai_sisa||0) <= 0 ? "text-success" : "text-danger";

		return (
		<CCard className="classbgcard mb-3" style={{flex: "1 0 0"}}>
		<CCardHeader className="py-0 pt-1 text-muted classfontsmaller"><small>Data Pembayaran</small></CCardHeader>
		<CCardBody className="py-1 px-2 px-lg-4">
			<small>
			<CRow className="my-2">
			<CCol xs="7" lg="6">Nilai Terapi &middot; (Rp)</CCol>
			<CCol className="text-end fw-bolder">{UFunc.formatAngka(uDatamainObj.nilai_bruto)}</CCol>
			</CRow>
			
			{(parseFloat(uDatamainObj.diskon)||0) > 0 && (
			<CRow className="my-2">
			<CCol className="text-danger">Diskon &middot; (Rp)</CCol>
			<CCol className="text-end fw-bolder">
				<div className="text-danger">{UFunc.formatAngka(uDatamainObj.diskon)}</div>
			</CCol>
			</CRow>
			)}

			<CRow className="my-2">
			<CCol xs="7" lg="6" style={{color:"purple"}}>
				<div>
					<span className="me-1 d-none d-lg-inline">Tanggungan</span>
					Asuransi
					<span className="ms-1">&middot;</span> (Rp)

					{(uDataloadObj.status_bayar||"")==="KASIR" && (
					<>
					<span className="mx-1">&middot;</span>
					<CTooltip className="d-none d-lg-block" content="--Pilih Asuransi">
					<CLink onClick={()=>hdlKlikAsuransi()} className="classcursorpointer">
					<CIcon icon="cilSearch" className="classikonbox align-middle mx-0" height={25}/>
					</CLink>
					</CTooltip>
					</>
					)}
				</div>

				{parseInt(uDatamainObj.id_asuransi||"0") > 0 && (
				<small>
				(<b>{uDatamainObj.nama_asuransi}</b>)
				</small>
				)}
			</CCol>
			<CCol className="text-end fw-bolder" style={{color:"purple"}}>
				{parseInt(uDatamainObj.id_asuransi||"0")<=0 ? (
				<>
					<i className="fw-normal">0</i>
				</>
				) : (
				<b>{UFunc.formatAngka(uDatamainObj.nilai_asuransi)}</b>
				)}
			</CCol>
			</CRow>

			{(uDataloadObj.status_bayar||"KASIR")!=="KASIR" && (
			<>
				<div className="my-3 classborderbottom"/>

				<CRow className="my-2">
				<CCol xs="7" lg="6">Nilai Total &middot; (Rp)</CCol>
				<CCol className="text-end fw-bolder">{UFunc.formatAngka(uDatamainObj.nilai_netto)}</CCol>
				</CRow>
				<CRow className="my-2">
				<CCol>Terbayar &middot; (Rp)</CCol>
				<CCol className="text-end fw-bolder">{UFunc.formatAngka(uDatamainObj.terbayar)}</CCol>
				</CRow>
			</>
			)}

			<div className="my-3 classborderbottom"/>

			<CRow className="my-2 text-success">
			<CCol xs="7"  d-none d-lg-inline="6">Nilai Tagihan &middot; (Rp)</CCol>
			<CCol className="text-end fw-bolder">{UFunc.formatAngka(uDatamainObj.nilai_akhir)}</CCol>
			</CRow>

			<div className="my-3 classborderbottom"/>

			<CRow className="my-2">
			<CCol xs="7" lg="6">
				<span className="text-primary">Metode Pembayaran</span>

				<span className="mx-1">&middot;</span>

				<CTooltip className="d-none d-lg-block" content="--Tambah Metode Pembayaran">
				<CLink onClick={hdlKlikPaymenttambah} className="classcursorpointer classikontabel classikontambah"/>
				</CTooltip>
			</CCol>
			<CCol className="text-end">[{(uDatamainObj.payment_arr||[]).length}]</CCol>
			</CRow>

			{(uDatamainObj.payment_arr||[]).map((vItems,vKeys)=>{

				const vCaptionupper	= (vItems.nama_payment||"").toUpperCase();

				return (
				<CRow className="my-1" key={vKeys}>
					<CCol xs="7" md="6" className="text-end">
					<span className="d-inline-block align-top">
						<div>
						<b>{vItems.nama_payment||"Undf"}</b>
						<span className="mx-1">&middot;</span>
						<span>(Rp)</span>
						</div>

						<div className="fst-italic classfontsmaller">
							<small>{vItems.ket_payment}</small>
						</div>
					</span>
					
					<span className="mx-1">&middot;</span>

					<CTooltip className="d-none d-lg-block" content={"--Hapus Metode: "+vCaptionupper}>
					<CLink onClick={()=>hdlKlikPaymenthapus(vKeys)} className="classcursorpointer classikontabel classikonhapus"/>
					</CTooltip>
					</CCol>
					<CCol className="text-end">{UFunc.formatAngka(vItems.jml_bayar)}</CCol>
				</CRow>
				)
			})}
			
			<CRow className="my-2 text-primary">
			<CCol xs="8" lg="6" className="fw-bolder"><big>JML BAYAR &middot; (Rp)</big></CCol>
			<CCol className="text-end fw-bolder">
				<big>{UFunc.formatAngka(uDatamainObj.nilai_uang)}</big>
				<NumberFormat 
					value={uDatamainObj.nilai_uang||"0"}
					displayType={'text'} 
					allowNegative={false}
					thousandSeparator={"."} 
					decimalSeparator={","}
					onValueChange={(values) => uDatamainObj.nilai_uang=values.value}
					renderText={values => (
						<CFormInput size="sm"
							value={values}
							className="text-end d-none"
							onChange={(e)=>{uDatamainObj.nilai_uang=e.target.value;setEfekview(!uEfekview)}}
							onFocus={(e)=>e.target.select()}
							onKeyDown={(e)=>{
								if(!document.getElementById("inpcatatanlain"))
									UFunc.hdlKeyDownInput(e,"btnSimpanmain")
							}}
						id="inpbayar"/>
					)} 
				prefix=""/>
			</CCol>
			</CRow>

			<div className="my-3 classborderbottom"/>

			<CRow className="my-2">
			<CCol className={vColorsisa}>
				{parseInt(uDatamainObj.nilai_sisa||0) <= 0 ? (
					<span className="">KEMBALI</span>
				) : (
				<>
					<span>SISA Cicilan</span>
					<span className="ms-1 d-none d-lg-inline">(PIUTANG)</span>
				</>
				)}
				<span className="mx-1">&middot;</span>(Rp)
			</CCol>
			<CCol className={("text-end fw-bolder ")+vColorsisa}>
				<big>{UFunc.formatAngka(Math.abs(uDatamainObj.nilai_sisa))}</big>
			</CCol>
			</CRow>
			</small>
		</CCardBody>
		</CCard>
		)//->
	}
	const contentDlgview = () => {
		if(!uIsDlgviewshow) return (<></>);

		const vPiutangArr 	= uDataloadObj.piutang_arr || [];
		let vJumlah 		= 0
		return (
		<>
		<small className="classfontsmaller">
		<CRow className="mx-0 py-1 classborderbottom fw-bold">
			<CCol md="1" className="text-center">No</CCol>
			<CCol md="2" className="text-start">Tgl Periksa</CCol>
			<CCol md="3" className="text-start">Dokter</CCol>
			<CCol md="2" className="text-center">N.Transaksi (Rp)</CCol>
			<CCol md="2" className="text-center">Terbayar (Rp)</CCol>
			<CCol md="2" className="text-center">Sisa (Rp)</CCol>
		</CRow>
		</small>

		{vPiutangArr.map((vItems,vKeys) => {
			const {
				id,tgl_piutang,nama_dokter,nilai_netto,terbayar
			} = vItems;

			const vSisa = parseInt(nilai_netto||0) - parseInt(terbayar||0);
			vJumlah		+= vSisa;
			return (
			<CRow className="mx-0 py-2 classborderbottom" key={vKeys}>
				<CCol md="1" className="text-end">{vKeys+1}.</CCol>
				<CCol md="2" className="px-1 text-start">{UFunc.TglAngka(tgl_piutang)}</CCol>
				<CCol md="3" className="px-0 classfontsmaller text-start fw-bolder text-primary">
					{nama_dokter||"UNDF,DRG"}</CCol>
				<CCol md="2" className="text-end">{UFunc.formatAngka(nilai_netto)}</CCol>
				<CCol md="2" className="text-end">{UFunc.formatAngka(terbayar)}</CCol>
				<CCol md="2" className="text-end text-danger">{UFunc.formatAngka(vSisa)}</CCol>
			</CRow>
			)
		})}

		<CRow className="mx-0 py-2 classborderbottom fw-bolder">
			<CCol md="10" className="text-end">JUMLAH (Rp)</CCol>
			<CCol md="2" className="text-end text-danger">{UFunc.formatAngka(vJumlah)}</CCol>
		</CRow>
		</>
		)//->
	}
	const contentDlgform = () => {
		if(!uIsDlgformshow) return (<></>)//->

		if(uDlgformObj.jenis_form === "FORMMAIN") return contentFormmain();
		if(uDlgformObj.jenis_form === "ASURANSI") return contentFormasuransi();
		if(uDlgformObj.jenis_form === "PAYMENT") return contentFormpayment();
		if(uDlgformObj.jenis_form === "TERAPI") return contentFormitem();

		return (<></>)//->
	}
	const contentFormitem = () => {
		if(uDlgformObj.jenis_form !== "TERAPI") return (<></>)//>

		return (
		<CForm>
		<CRow className="my-2">
		<CCol xs="4" className="">
			<small className="d-md-none">Nama ITEM</small>
			<span className="d-none d-md-block">Nama ITEM</span>
		</CCol>
		<CCol className="text-end text-md-start">
			{(parseInt(uDlgformObj.item_id)||0) <= 0 ? (
			<CInputGroup size="sm">
			<CFormInput size="sm"
				placeholder="--PILIH NAMA TERAPI"
				value={uDlgformObj.terapi_caption}
				onChange={(e)=>{uDlgformObj.terapi_caption=e.target.value;setEfekview(!uEfekview)}}
				onKeyDown={(e)=>hdlKDownItemlookup(e)}
				id="inpitemcaption"/>
			<CButton size="sm" color="dark" onClick={()=>hdlKlikItemlookup()} id="btnitemlookup">
				<CIcon icon="cilSearch"/>
			</CButton>
			</CInputGroup>
			) : (
				<span className="fst-italic text-primary mb-2">{uDlgformObj.terapi_caption}</span>
			)}
		</CCol>
		</CRow>

		<CRow className="my-2">
		<CCol xs="4" className="">
			<small className="d-md-none">Tarif Terapi</small>
			<span className="d-none d-md-block">Tarif Terapi</span>
		</CCol>
		<CCol className="text-end fw-bolder text-primary">
			<CFormInput size="sm"
				readOnly={true}
				value={"Rp"+UFunc.formatAngka(uDlgformObj.terapi_tarif)}
				className="text-end text-primary"
				id="inpitemtarif"/>
		</CCol>
		<CCol md="4" className="d-none d-md-block"/>
		</CRow>

		<div className="my-3 classborderbottom"/>
		
		<CRow className="my-2">
		<CCol xs="4" className="">
			<small className="d-md-none">JML</small>
			<span className="d-none d-md-block">JML</span>
		</CCol>
		<CCol className="text-end text-md-start">
			<CInputGroup size="sm">
			<CFormInput size="sm" type="number"
				min={1} step={1}
				className="text-end"
				value={uDlgformObj.terapi_qty || 0}
				onChange={(e)=>{uDlgformObj.terapi_qty=e.target.value;setEfekview(!uEfekview)}}
				onFocus={(e)=>e.target.select()}
				id="inpitemqty"/>
			<CInputGroupText>UNIT</CInputGroupText>
			</CInputGroup>
		</CCol>
		<CCol md="4" className="d-none d-md-block"/>
		</CRow>
		
		<CRow className="my-2">
		<CCol xs="4" className="text-danger">
			<small className="d-md-none">Diskon</small>
			<span className="d-none d-md-block">Diskon Terapi</span>
		</CCol>
		<CCol className="text-end text-md-start">
			<CInputGroup size="sm">
			<NumberFormat 
				value={uDlgformObj.terapi_diskon||0}
				displayType={'text'} 
				allowNegative={false}
				thousandSeparator={"."} 
				decimalSeparator={","}
				onValueChange={(values) => uDlgformObj.terapi_diskon=values.value}
				renderText={values => (
					<CFormInput size="sm"
						value={values}
						className="text-end"
						onChange={(e)=>{uDlgformObj.terapi_diskon=e.target.value;setEfekview(!uEfekview)}}
						onFocus={(e)=>e.target.select()}
						onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
					id="inpitemdiskon"/>
				)} 
			prefix={isMobile?"":"Rp"}/>
			</CInputGroup>
		</CCol>
		<CCol md="4" className="d-none d-md-block"/>
		</CRow>

		<div className="my-3 classborderbottom"/>

		<CRow className="my-3">
		<CCol xs="4" className=" text-success">
			<small className="d-md-none">Total Tarif</small>
			<span className="d-none d-md-block">Total Terapi</span>
		</CCol>
		<CCol className="text-end fw-bolder text-success">
			{"Rp"+UFunc.formatAngka(
				((parseFloat(uDlgformObj.terapi_tarif)||0) - (parseFloat(uDlgformObj.terapi_diskon)||0))
				* (parseInt(uDlgformObj.terapi_qty)||1)
			)}
		</CCol>
		<CCol md="4" className="d-none d-md-block"/>
		</CRow>
		</CForm>
		)//
	}
	const contentFormasuransi = () => {
		if(uDlgformObj.jenis_form !== "ASURANSI") return (<></>)//>

		return (
		<CForm>
		
		<CRow className="my-1">
		<CCol className="text-center">
			<div className="fw-bolder text-success">
			Rp.{UFunc.formatAngka( parseFloat(uDatamainObj.nilai_bruto) - parseFloat(uDatamainObj.diskon) )}
			</div>
			<div  className="classpetunjuk px-0"><small>Nilai Transaksi</small></div>
		</CCol>
		</CRow>

		<div className="my-1 text-center classfontsmaller">
		<small>
		<CLink onClick={()=>{
			uDlgformObj.asuransi_caption = "";
			uDlgformObj.asuransi_id = 0;
			uDlgformObj.nilai_asuransi = 0;
			uDlgformObj.asuransi_nomor = "";
			setEfekview(!uEfekview);
		}} className="text-normal classcursorpointer">[CLEAR]</CLink>
		</small>
		</div>

		<div className="my-3 classborderbottom"/>

		<CRow className="my-2">
		<CCol xs="3" md="4">
			<small className="d-md-none">Nama Asuransi</small>
			<span className="d-none d-md-block">Nama Asuransi</span>
		</CCol>
		<CCol>
			<CInputGroup size="sm">
			<CFormInput size="sm"
				placeholder="--Pilih Nama Asuransi.."
				readOnly={true}
				value={uDlgformObj.asuransi_caption}
				onChange={(e)=>{uDlgformObj.asuransi_caption=e.target.value;setEfekview(!uEfekview)}}
				onClick={()=>hdlKlikAsuransilookup()}
				id="inpasuransicaption"/>
			<CButton size="sm" color="dark"
				onClick={()=>hdlKlikAsuransilookup()}
				id="btnAsuransilookup">
				<CIcon icon="cilSearch"/>
			</CButton>
			</CInputGroup>
		</CCol>
		</CRow>

		<CRow className="my-2">
		<CCol xs="3" md="4">
			<small className="d-md-none">Nomor Asuransi</small>
			<span className="d-none d-md-block">Nomor Asuransi</span>
		</CCol>
		<CCol>
			<CFormInput size="sm"
				placeholder="--Nomor Asuransi.."
				maxLength={50}
				value={uDlgformObj.asuransi_nomor}
				onChange={(e)=>{uDlgformObj.asuransi_nomor=e.target.value;setEfekview(!uEfekview)}}
				id="inpasuransinomor"/>
		</CCol>
		</CRow>

		<div className="my-3 classborderbottom"/>

		<CRow className="my-2">
		<CCol xs="3" md="4">
			<small className="d-md-none">Nilai Tanggungan</small>
			<span className="d-none d-md-block">Nilai Tanggungan</span>
		</CCol>
		<CCol>
			<NumberFormat 
				value={uDlgformObj.nilai_asuransi||0}
				displayType={'text'} 
				allowNegative={false}
				thousandSeparator={"."} 
				decimalSeparator={","}
				onValueChange={(values) => uDlgformObj.nilai_asuransi=values.value}
				renderText={values => (
					<CFormInput size="sm"
						value={values}
						className="text-end"
						onChange={(e)=>{uDlgformObj.nilai_asuransi=e.target.value;setEfekview(!uEfekview)}}
						onFocus={(e)=>e.target.select()}
						onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
					id="inpasuransinilai"/>
				)} 
			prefix={isMobile?"":"Rp"}/>
		</CCol>
		</CRow>
		</CForm>
		)//->
	}
	const contentFormpayment = () => {
		if(uDlgformObj.jenis_form !== "PAYMENT") return (<></>)//>

		return (
		<CForm>
		<CRow className="my-2 text-danger">
			<CCol xs="3" md="4">
			<small className="d-md-none">Sisa</small>
			<span className="d-none d-md-block">Sisa Tagihan (Rp)</span>
			</CCol>

			<CCol className="text-end fw-bolder">{UFunc.formatAngka(uDatamainObj.nilai_sisa)}</CCol>
		</CRow>
			
			<div className="my-3 classborderbottom"/>

		<CRow className="my-2">
			<CCol xs="3" md="4">
			<small className="d-md-none">Metode</small>
			<span className="d-none d-md-block">Metode Payment</span>
			</CCol>
			<CCol>
			<CInputGroup size="sm">
			<CFormInput size="sm"
				value={uDlgformObj.payment_caption||""}
				readOnly={true}
				onClick={()=>hdlKlikPaymentlookup()}
				placeholder="--Kosongi Jika TUNAI (CASH).."
				id="inppaymentcaption"/>
			{parseInt(uDlgformObj.payment_id||0) > 0 && (
			<CInputGroupText className="py-0 bg-transparent">
				<CLink className="classcursorpointer"
					onClick={()=>{uDlgformObj.payment_id=0;uDlgformObj.payment_caption="";setEfekview(!uEfekview)}}>
				<CIcon icon="cilXCircle" className="text-danger"/>
				</CLink>
			</CInputGroupText>
			)}
			<CInputGroupText className="py-0 bg-dark">
			<CTooltip className="d-none d-lg-block" content="--Pilih Metode Pembayaran">
			<CLink 
				className="classcursorpointer"
				onClick={()=>hdlKlikPaymentlookup()}>
				<CIcon icon="cilMagnifyingGlass" className="text-light"/>
			</CLink>
			</CTooltip>
			</CInputGroupText>
			</CInputGroup>
			</CCol>
		</CRow>

		{(parseInt(uDlgformObj.payment_id) || 0) > 0 && (
		<CRow className={"my-2 "}>
			<CCol xs="3" md="4">
			<small className="d-md-none">Ket.Payment</small>
			<span className="d-none d-md-block">Ket.Payment</span>
			</CCol>

			<CCol>
			<CFormInput size="sm" maxLength={255}
				readOnly={false}
				className="text-capitalize"
				value={uDlgformObj.payment_ket||""}
				onChange={(e)=>{uDlgformObj.payment_ket=e.target.value;setEfekview(!uEfekview)}}
				id="inppaymentket"/>
			</CCol>
		</CRow>
		)}

		<div className="classborderbottom my-3"/>

		<CRow className="my-2">
			<CCol xs="3" md="4">
				<small className="d-md-none">Jml Bayar</small>
				<span className="d-none d-md-block">Jml Bayar (Rp)</span>
			</CCol>
			<CCol>
				<NumberFormat 
					value={uDlgformObj.jml_bayar||"0"}
					displayType={'text'} 
					allowNegative={false}
					thousandSeparator={"."} 
					decimalSeparator={","}
					onValueChange={(values) => uDlgformObj.jml_bayar=values.value}
					renderText={values => (
						<CFormInput size="sm"
							value={values}
							className="text-end"
							onChange={(e)=>{uDlgformObj.jml_bayar=e.target.value;setEfekview(!uEfekview)}}
							onFocus={(e)=>e.target.select()}
							onKeyDown={(e)=>UFunc.hdlKeyDownInput(e,"btnDialogSimpan")}
						id="inpjmlbayar"/>
					)} 
				prefix=""/>
			</CCol>
		</CRow>
		</CForm>
		)//->
	}
	const contentFormmain = () => {
		if(uDlgformObj.jenis_form !== "FORMMAIN") return (<></>)//>

		return (
		<CForm>
		<CRow className="my-1">
		<CCol>Tgl Bayar</CCol>
		<CCol className="text-end fw-bolder">{UFunc.TglAngka(uDatamainObj.tgl_bayar)}</CCol>
		</CRow>

		{parseInt(uDatamainObj.id_asuransi||"0") > 0 && (
		<CRow className="my-1">
		<CCol className="" style={{color:"purple"}}>Asuransi (<b>{uDatamainObj.nama_asuransi}</b>)</CCol>
		<CCol className="text-end fw-bolder" style={{color:"purple"}}>{UFunc.formatAngka(uDatamainObj.nilai_asuransi)}</CCol>
		</CRow>
		)}

		<CRow className="my-1">
		<CCol>Nilai Tagihan</CCol>
		<CCol className="text-end fw-bolder">{UFunc.formatAngka(uDatamainObj.nilai_akhir)}</CCol>
		</CRow>

		<div className="my-3 classborderbottom"/>

		<CRow className="my-1">
		<CCol className="text-primary">Jml BAYAR</CCol>
		<CCol className="text-end fw-bolder text-primary">{UFunc.formatAngka(uDatamainObj.nilai_uang)}</CCol>
		</CRow>

		<CRow className="my-1">
		{parseInt(uDatamainObj.nilai_sisa||0) > 0 ? (
		<>
			<CCol className="text-danger"><big>Sisa Piutang</big></CCol>
			<CCol className="text-end fw-bolder text-danger"><big>{UFunc.formatAngka(uDatamainObj.nilai_sisa)}</big></CCol>
		</>
		) : (
		<>
			<CCol className="text-success">Kembalian</CCol>
			<CCol className="text-end fw-bolder text-success">{UFunc.formatAngka(Math.abs(uDatamainObj.nilai_sisa))}</CCol>
		</>
		)}
		</CRow>
		</CForm>
		)//->
	}
	const contentCetaknota = () => {
		if(JSON.stringify(uDatacetakObj||{}) === "{}") return "";
		//console.log("(Bayar - contentCetaknota) uDatacetakObj => "+JSON.stringify(uDatacetakObj))

		const vCabangObj	= uCabanginitObj;

		let vHTMLs 	= uHTMLstylenota;
		vHTMLs 		= vHTMLs.replace(/_LEBARKERTAS_/g, (uLebarKertas<=0?"auto":uLebarKertas+"mm"));//-->PAKESATUAN
		vHTMLs 		= vHTMLs.replace(/_MARGINKIRI_/g,uMarginKiri);
		vHTMLs 		= vHTMLs.replace(/_FONTSIZE_/g,uFontsize);
		vHTMLs 		= vHTMLs.replace(/_FONTFAMILY_/g,uFontstyle);

		const vIsWithlogo	= uViewLogo==="YA";// (uSystemsettingObj.view_image_nota||"TIDAK")==="YA";
		const vURLlogo		= (uSystemsettingObj.url_image_nota||"").trim() === "" ? uUrllogoDefault
			: uSystemsettingObj.url_image_nota;//getBase64Image(document.getElementById("idimglogo"));

		const vMainbody	= UFunc.Rendernota(uDatacetakObj);
		vHTMLs 			+=  vMainbody;
		//---LOGO--/
		let vLogoheader	= "";
		if(vIsWithlogo) 
			vLogoheader = `
			<tr valign="top">
			<td colSpan="4" align="center">
				<img src="`+vURLlogo+`" height="20mm" style="height:20mm" />
			</td>
			</tr>
			`;
		//---END LOGO--/

		//---TELP--/
		let vTelpPerusahaan	= "";
		if((vCabangObj.telp_hp || "") !== "")
			vTelpPerusahaan += `
			<tr valign="top">
			<td colSpan="4" align="center">`+
				(uBahasaObj.caption_telphp||"Telp/WA")+". "+
				UFunc.capitalize(vCabangObj.telp_hp || "").toUpperCase()+
				//`<div>`+vIsWithlogo+`</div>`+
			`</td>
			</tr>
			`;
		//---END TELP--/

		const vFooternota = (vCabangObj.footer_nota||"").trim() !=="" ?
			`
			<tr>
			<td colSpan="4"><hr/></td>
			</tr>
			<tr>
			<td colSpan="4" align="center">`+(vCabangObj.footer_nota||"")+`</td>
			</tr>
			` : ``;

		vHTMLs 		= vHTMLs.replace(/_TRBODYLOGO_/g,vLogoheader);
		vHTMLs 		= vHTMLs.replace(/_NAMAPERUSAHAAN_/g,(vCabangObj.nama_klinik || "Dental Care").toUpperCase());
		vHTMLs 		= vHTMLs.replace(/_ALAMATPERUSAHAAN_/g,UFunc.capitalize(vCabangObj.alamat_klinik || ""));
		vHTMLs 		= vHTMLs.replace(/_TRBODYTELP_/g,vTelpPerusahaan);
		vHTMLs 		= vHTMLs.replace(/_TRFOOTERNOTA_/g,vFooternota);

		return vHTMLs		
	}
	//---END CONTENT--/

	//---REST_API--/
	const apiLoadawal = () => {
		setHtml500msg();

		//uDispatch({type: "set", kasirdata:undefined});
		setDataloadObj({})
		setDatamainObj({})
		//setDataterapiArr([]); setDatapaymentArr([])
		setLoadingform(true);
		setLoading(true);

		/*//--TESTING_FRONTEND--/
		let vTimeout = setTimeout(()=>{
			clearTimeout(vTimeout);
			setLoadingform(false);
			setLoading(false);
		},2500); return;
		//--END TESTING_FRONTEND--*/

		const vDATAS	= JSON.stringify({
			send_rekammedisid : uRekammedisID,
			send_firstload : uFirstload,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_bayar/ld_init";

		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			const vTimeEnd = new Date(); const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
			setLoadingform(false);
			setLoading(false);
			if(output_string.tampil) {
				//uDispatch({type: "set", kasirdata: JSON.parse(output_string.datamain||"{}")})
				setDataloadObj(JSON.parse(output_string.datamain||"{}"))

				setDataterapiArr(JSON.parse(output_string.dataterapi||JSON.stringify(uDataterapiArr)))
				setDatapaymentArr(JSON.parse(output_string.datapayment||JSON.stringify(uDatapaymentArr)))
				setDataasuransiArr(JSON.parse(output_string.dataasuransi||JSON.stringify(uDataasuransiArr)))
				if(uFirstload==="YA") {
					setFirstload("TIDAK")
				}
				//console.log("(Bayar - apiLoadawal) output_string.datapayment => "+(output_string.datapayment))
				setEfekview(!uEfekview);
			} else if(output_string.info) {
				setHtml500msg(output_string.info);
			} else if(output_string.errors) {
				console.log("(Bayar - apiLoadawal) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				setHtml500msg("<div class='text-danger'>"+vMsg+"</div>");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired(); return
			}

			if(vTimeDiff > 500) setSessionaktif(true);
			else {
				let vTimeout = setTimeout(()=>{ clearTimeout(vTimeout); setSessionaktif(true);},500)
			}
		})
		.catch((error) =>{
			setLoadingform(false);
			setLoading(false);
			console.log("(Bayar - apiLoadawal) catch-error : "+error);
			setHtml500msg(pjson.mydefault.msg500str.join(" "));
		});
	}
	const apiLoadpiutang = () => {
		uDatamainObj.isLoadpiutang 	= true;
		setEfekview(!uEfekview);

		const vDATAS	= JSON.stringify({
			send_pasienid : uDataloadObj.id_pasien||0,
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_bayar/ld_perpasien";

		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			const vTimeEnd = new Date(); const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
			uDatamainObj.isLoadpiutang 	= false;
			if(output_string.tampil) {
				uDataloadObj.piutang_arr = JSON.parse(output_string.datapiutang || "[]");
				setDlgviewshow(true); 
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Bayar - apiLoadpiutang) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired(); return
			}

			if(vTimeDiff > 500) setSessionaktif(true);
			else {
				let vTimeout = setTimeout(()=>{ clearTimeout(vTimeout); setSessionaktif(true);},500)
			}
		})
		.catch((error) =>{
			uDatamainObj.isLoadpiutang 	= false;
			console.log("(Bayar - apiLoadpiutang) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	const apiProsessimpan = () => {
		const vEldisabled = document.getElementById("btnDialogSimpan");
		vEldisabled && (vEldisabled.disabled=true);
		setLoading(true); 
		setDatacetakObj({});

		const vDATAS	= JSON.stringify({
			send_rekammedisid : uRekammedisID,
			send_databayar: JSON.stringify(uDatamainObj),
			send_tokenauth : uTokenObj.userinit
		});
		const vURLs	= pjson.homepage+"api/api_bayar/pr_bayar";
		//const vURLs	= pjson.homepage+"api/api_bayar/pr_test";

		const vTimeBegin = new Date();
		fetch(vURLs,{
			headers: { Accept: "application/json", "Content-Type": "application/json" },
			method: "POST",
			mode: "cors",
			cache: "default",
			body: vDATAS,
		}).then((response)=> { if (response.status === 200) { setSessionaktif(false); return response.json(); }})
		.then((output_string) => {
			const vTimeEnd = new Date(); const vTimeDiff = vTimeEnd - vTimeBegin; //in ms
			vEldisabled && (vEldisabled.disabled = false);
			setLoading(false); 
			if(output_string.sukses) {
				hdlToggleDlgform();
				const vNotaObj	= JSON.parse(output_string.datanota||"{}");
				if(JSON.stringify(vNotaObj)==="{}") {
					showToast((uBahasaObj.pesan_kasirsukses||"Berhasil.."),"SUKSES");
					uNavigate(uUrlbefore,{replace:true}); return;
				}
				setDatacetakObj(vNotaObj);
			} else if(output_string.info) {
				showToast(output_string.info);
			} else if(output_string.errors) {
				console.log("(Bayar - apiProsessimpan) output_string.errors : "+output_string.errors);
				const vMsg = (pjson.mydefault.environment==="development")
					? output_string.errors : pjson.mydefault.msgFetchError;
				showToast(vMsg,"ERROR");
			} else if(output_string.expired) {
				setLoading(true); prosesExpired(); return
			}

			if(vTimeDiff > 500) setSessionaktif(true);
			else {
				let vTimeout = setTimeout(()=>{ clearTimeout(vTimeout); setSessionaktif(true);},500)
			}
		})
		.catch((error) =>{
			vEldisabled && (vEldisabled.disabled = false);
			setLoading(false); 
			console.log("(Bayar - apiProsessimpan) catch-error : "+error);
			showToast(pjson.mydefault.msg500str.join(" "),"ERROR");
		});
	}
	//---END REST_API--/

	//---EFFECT--/
	React.useEffect(()=>{
		document.addEventListener("keydown",hdlKDownDocument);

		return ()=>{
			document.removeEventListener("keydown",hdlKDownDocument);
		}
	})
	React.useEffect(()=>{
		uDispatch({type: "set", effectApp: !uEfekapp});

		apiLoadawal();

    	return () => {
    		uDispatch({type: "set", gFormantrianstr: undefined});
			setDlgformshow(false);
			setDlgformntrianshow(false);
			setDlgviewshow(false);
			setDlglookupshow(false);
    		setDataloadObj({});
    		setDatamainObj({});
			setDataterapiArr([])
			setDatapaymentArr([])
			setDataasuransiArr([])
			setFirstload("YA")
			setDatacetakObj({});
    	}
	},[])
	React.useEffect(()=>{ 
		initCopyloadobj();
		setEfekview(!uEfekview)
	},[uDataloadObj])
	React.useEffect(()=>{ 
		if(JSON.stringify(uDatamainObj||{}) === "{}") return;
		if(uDatamainObj.init_difference === undefined) return;

		const vItemmainArr			= uDatamainObj.items_arr || [];
		uDatamainObj.items_arr 		= undefined;

		const vItemnewArr	= vItemmainArr.map(vItems=> {
			const vTmpObj = {...vItems,diff:"YA"}
			return (vTmpObj);
		});
		uDatamainObj.itemmain_arr 	= vItemnewArr;

		setEfekview(!uEfekview)
	},[uDatamainObj])
	React.useEffect(()=>{ 
		//console.log("(Bayar - [uDatamainObj,uDatamainObj.tgl_bayar]) uDataloadObj => "+JSON.stringify(uDataloadObj))
		//console.log("(Bayar - [uDatamainObj,uDatamainObj.tgl_bayar]) uDatamainObj => "+JSON.stringify(uDatamainObj))
		if(uDatamainObj.tgl_bayar===undefined) {
			uDatamainObj.tgl_bayar = UFunc.DbDate();
		}
	},[uDatamainObj,uDatamainObj.tgl_bayar])
	React.useEffect(()=>{ 
		//if((uDataloadObj.status_bayar||"KASIR") !== "KASIR") return;
		initNilaibruto();
	},[uDatamainObj,
	uDatamainObj.itemmain_arr,
	(uDatamainObj.itemmain_arr||[]).filter(vItems=>(vItems.status_hapus||"TIDAK")==="TIDAK").length
	])
	React.useEffect(()=>{ initNilaiakhir(); },[uDatamainObj.nilai_bruto])
	React.useEffect(()=>{//--TIDAK_DIPAKAI--/
		const vNilaibruto 	= (parseInt(uDatamainObj.nilai_bruto) || 0);
		const vDiskon 		= (parseInt(uDatamainObj.diskon) || 0);
		const vMaxdiskon 	= (parseFloat(uSystemsettingObj.persen_diskonmax) || 100);
		if(vDiskon > ((vMaxdiskon/100)*vNilaibruto)) {
			uDatamainObj.diskon = (vMaxdiskon/100) * vNilaibruto;
			setEfekview(!uEfekview); return
		}
		initNilaiakhir()
		setEfekview(!uEfekview)
	},[uDatamainObj,uDatamainObj.diskon])//-*/
	React.useEffect(()=>{ 
		initNilaiakhir();
		setEfekview(!uEfekview)
	},[uDatamainObj,uDatamainObj.nilai_asuransi])
	React.useEffect(()=>{ 
		const vNilaibayar = (uDatamainObj.payment_arr||[]).reduce((vSUM,vItems)=>
			vSUM + (parseFloat(vItems.jml_bayar)||0)
			,0)

		uDatamainObj.nilai_uang = vNilaibayar;
	},[uDatamainObj,
	(uDatamainObj.payment_arr||[]).length
	])
	React.useEffect(()=>{ 
		const vNilaisisa = 
			(parseInt(uDatamainObj.nilai_akhir)||0)
				 - (parseInt(uDatamainObj.nilai_uang) || 0)
		uDatamainObj.nilai_sisa = vNilaisisa;
		setEfekview(!uEfekview)
	},[uDatamainObj,
	uDatamainObj.nilai_bruto,
	uDatamainObj.diskon,
	uDatamainObj.nilai_asuransi,
	uDatamainObj.nilai_uang])
	React.useEffect(()=>{ 
		const vItemloadArr	= uDataloadObj.items_arr || [];
		const vItemmainArr	= (uDatamainObj.itemmain_arr || []).
			filter(vItems => (vItems.status_hapus||"TIDAK")==="TIDAK");

		if((uDatamainObj.tgl_bayar||"") !== UFunc.DbDate()
			|| parseInt(uDatamainObj.diskon||0) !== parseInt(uDataloadObj.diskon||0)
			|| parseInt(uDatamainObj.nilai_uang||0) > 0
			|| parseInt(uDatamainObj.id_payment||0) > 0
			|| parseInt(uDatamainObj.id_asuransi||0) > 0
			|| (uDatamainObj.note_nota||"").trim() !== (uDataloadObj.note_nota||"").trim()
			|| vItemloadArr.length !== vItemmainArr.length
		) setFormupdate(true);
		else setFormupdate(false);
	},[uDatamainObj,
	uDatamainObj.tgl_bayar,
	uDatamainObj.diskon,
	uDatamainObj.nilai_uang,
	uDatamainObj.id_asuransi,
	uDatamainObj.note_nota,
	(uDatamainObj.itemmain_arr||[]).filter(vItems=>(vItems.status_hapus||"TIDAK")==="TIDAK").length,
	(uDatamainObj.itemmain_arr||[]).length,
	uDatamainObj.id_payment,
	])
	React.useEffect(()=>{ 
		if(!uIsDlgformshow) {
			setDlgformheader(""); setDlgformObj({});
			return;
		}
	},[uIsDlgformshow])
	React.useEffect(()=>{ 
		if(!uIsDlgviewshow) {
			setDlgviewheader("");
			return;
		}
	},[uIsDlgviewshow])
	React.useEffect(()=>{ 
		if(!uIsDlglookupshow) {
			setInpDlglookup("");
			setDlglookupjenis("");
			setDataDlglookupArr([]);
			setDlglookupheader("");
			return;
		}
	},[uIsDlglookupshow])
	React.useEffect(()=>{
		if(JSON.stringify(uDatacetakObj||{})==="{}") return;

		//---CETAK_NOTA--/
		initCetaknota()
		//---END CETAK_NOTA--/
		showToast((uBahasaObj.pesan_kasirsukses||"Berhasil.."),"SUKSES");
		uNavigate(uUrlbefore,{replace:true});
	},[uDatacetakObj])
	React.useEffect(()=>{
		if(!uFrameExport) return;

		const pri 		= uFrameExport.contentWindow; if(!pri) return;
		const vURLlogo	= (uSystemsettingObj.url_image_nota||"").trim() === "" 
			? pjson.homepage+"api/images/header_nota.png"
			: uSystemsettingObj.url_image_nota;
		pri.document.open();
		pri.document.write(`<img src="`+vURLlogo+`"/>`);
		pri.document.close();
	},[uFrameExport])
	//---END EFFECT--/

	//console.log("(Bayar) uNavigate => "+JSON.stringify(uNavigate))
	if(UFunc.isEmpty(uTokenObj)) { prosesExpired(); return ""; }

	return (
		<>
		<div className="wrapper d-flex flex-column min-vh-100 bg-transparent">
		<CHeader position="sticky" className="mb-4 p-0">
		<CContainer fluid className="classheadertop" style={{minHeight:64}}>
			<CHeaderToggler className="px-0"
				onClick={() => hdlKlikBack() }>
			<CIcon icon="cilArrowCircleLeft" className="align-top me-2" height={30}/>
			</CHeaderToggler>
			
			<CHeaderNav className="me-auto text-normal d-md-block">
				<div className="my-0">
				<b>{uBahasaObj.caption_bayarbilling||"Kasir Billing"}:{" "}
					{uDatamainObj.status_bayar!=="PIUTANG"?"PERIKSA":(<span className="text-danger">PIUTANG</span>)}</b>
				</div>
				
				<div className="classfontsmaller d-none d-lg-block">
					<small className="classfontsmaller">&middot; {uTokenObj.usercaption} &middot;</small>
				</div>
			</CHeaderNav>

			<CHeaderNav>
				<MyHeaderProfile {...props}/>
			</CHeaderNav>
		</CContainer>

		<CContainer fluid className="bg-white p-2 px-3" style={{minHeight:52}}>
			{uIsLoadingform===true ? (
				<div className="text-primary classblinking fst-italic mx-auto">Loading...</div>
			) : (
			<>
			{(uHtml500msg) ? (
			<div className="fw-bold">Ooops, Sorry...</div>
			) : (
			<div>
				<big className="text-info fw-bold">{uDatamainObj.pasien_caption}</big>
				{(uDatamainObj.ket_janjian||"")!=="" && (
				<>
				<span className="mx-1">&middot;</span>
				<small className="fst-italic text-primary">{uDatamainObj.ket_janjian}</small>
				</>
				)}
				{(()=>{
					if(parseInt(uDatamainObj.pasien_asuransi_id||0) <= 0) return (<></>);

					const vArridx = UFunc.getObjectIndeks(uDataasuransiArr,(uDatamainObj.pasien_asuransi_id||0));
					return (
					<>
						<span className="mx-1">&middot;</span>
		
						<CBadge color="light" style={{color:"purple",border:"1px solid purple"}}>
						<small className="fst-italic">{(uDataasuransiArr[vArridx]||{}).asuransi_caption}</small>
						{(uDatamainObj.pasien_asuransi_nomor||"")!=="" && (
						<>
							<small className="mx-1">&middot;</small>
							<small className="">{uDatamainObj.pasien_asuransi_nomor}</small>
						</>
						)}
						</CBadge>
					</>
					)
				})()}
			</div>
			)}

			<div>
			<CTooltip className="d-none d-lg-block" content="--Reset Form Pembayaran">
			<CLink className="classikon classikonreset classcursorpointer"
				 onClick={()=>hdlKlikReset()}/>
			</CTooltip>
			</div>
			</>
			)}
		</CContainer>
		</CHeader>

		{!uISCellphone ? (
		<>
		<div className="body flex-grow-1 px-2">
		<CContainer fluid className="px-0">
			{(uHtml500msg) ? (
				<CCard className="classbgcard mx-lg-5">
				<CCardHeader><b>Page 500</b></CCardHeader>
				<CCardBody>{UFunc.renderHTML(uHtml500msg)}</CCardBody>
				</CCard>
			) : (
			<CForm>
				<CRow className="mx-0">
				<CCol md="6" style={{display:"flex",flexDirection:"column"}}>
				{contentNota()}
				{contentItem()}
				{contentCatatan()}
				</CCol>

				<CCol md="6" style={{display:"flex",flexDirection:"column"}}>
				{contentAntrian()}
				{contentBayar()}
				</CCol>
				</CRow>
			</CForm>
			)}
		</CContainer>
		</div>

		<CFooter position="sticky" className="text-black-50 justify-content-center" 
			style={{backgroundColor:"#AEAEAE88",borderTop:"1px dashed #f0f0f0"}}>
		<MyButton
			disabled={uIsDlgviewshow 
				|| uIsLoadingform || uHtml500msg
				|| uIsDlglookupshow || uIsDlgformshow}
			onClick={()=>hdlKlikSimpanmain()}
			id="btnSimpanmain">{uBahasaObj.word_simpan||"Simpan"} [F9]</MyButton>
		</CFooter>

		</>
		) : (
		<div className="body flex-grow-1 px-2 px-lg-5 mt-2">
		<CContainer fluid className="px-0">
			<CCard className="classbgcard mb-2">
			<CCardHeader className="fw-bolder">Mobile Mode Forbidden</CCardHeader>
			<CCardBody className="px-md-5">
				<p>Maaf,</p>
				<p className="fw-bold">Fitur Ini Tidak Tersedia untuk Smartphone dan Tablet..</p>
				<p>Mohon Gunakan PC/Laptop yang Terhubung dengan Printer Nota..</p>
				<p className="fw-bold">Terima Kasih,</p>
			</CCardBody>
			</CCard>
		</CContainer>
		</div>
		)}
		</div>

		<MyDialoglookup
			show={uIsDlglookupshow}
			toggle={()=>hdlDlgLookuptoggle()}
			dialogHeader={uDlglookupheader||"Lookup Data"}
			inputValue={uInpDlglookup}
			dataItemArr={uDataDlglookupArr} 
			onKlikPilihItem={hdlDlgLookupPILIH}
			id="iddialoglookup"
			{...props}/>

		<MyDialogview
			options={{centered:true,size:"lg"}}
			show={uIsDlgviewshow} 
			dialogHeader={uDlgviewheader}
			toggle={hdlToggleDlgview}
			renderContent={contentDlgview()}/>

		<MyDialogform
			options={{centered:true}}
			show={uIsDlgformshow} 
			dialogHeader={uDlgformheader}
			toggle={hdlToggleDlgform}
			onSimpan={hdlKlikDlgformsimpan}
			renderContent={contentDlgform()}/>

		<MyDialogformantrian
			show={uISDlgformntrianshow} 
			toggle={()=>setDlgformntrianshow(false)}
			onSimpan={hdlKlikDlgformantriansimpan}
			{...props}/>

		<iframe id="ifmcontentstoprint" className="d-none"/>
		</>
	)//>
}	

export default Bayar